import merge from 'lodash/merge';
import styled, { css } from 'styled-components';
import { shouldIgnoreProp } from '../../utils/shouldIgnoreProp';
import { breakpoint } from '../../utils/styles/breakpoints';
import { ImageProps } from './Image';

export const Img = styled.img.withConfig({
    displayName: 'Img',
    shouldForwardProp: shouldIgnoreProp('objectFit', 'objectPosition', 'isLoaded'),
})<ImageProps & { isLoaded: boolean }>`
    display: block;
    width: 100%;
    object-position: center;
    -webkit-user-drag: none;
    user-drag: none;
    user-select: none;
    transition: opacity 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    pointer-events: none;

    ${css<ImageProps & { isLoaded: boolean }>((props) =>
        merge(
            breakpoint('opacity', props.isLoaded ? 1 : 0),
            breakpoint('objectFit', props.objectFit ?? 'cover'),
            breakpoint('objectPosition', props.objectPosition),
            breakpoint('width', props.width),
            breakpoint('maxWidth', props.maxWidth),
        ),
    )}
`;
